import Cookies from 'js-cookie';
import { useCallback, useEffect } from 'react';

import { Actions } from '../actions/enums';
import { Cookie } from '../network/enums';
import { getCookieDomain } from '../network/utils/getCookieDomain';
import { getRetailUnitCookiePath } from '../network/utils/getRetailUnitCookiePath';

export const useSession = () => {
  const userLogoutCallback = useCallback(async () => {
    Cookies.remove(Cookie.IKEA_SESSION, { domain: getCookieDomain, path: getRetailUnitCookiePath });
  }, []);

  useEffect(() => {
    window.ikea.pubsub?.subscribe?.(Actions.USER_LOGGED_OUT, userLogoutCallback);
    return () => window.ikea.pubsub?.unsubscribe?.(Actions.USER_LOGGED_OUT, userLogoutCallback);
  }, [userLogoutCallback]);
};
